<template>
  <div>
    <v-toolbar style="background-color: white !important;">
      <v-btn icon @click="toPage()">
        <v-icon>chevron_left</v-icon>
      </v-btn>
      <h2>สร้างบัญชีร้านค้า</h2>
    </v-toolbar>
    <v-card-text style="justify-content: center !important; height: calc(100vh - 120px); width: 100%; margin-right: auto; margin-left: auto;" class="scrolling-wrapper">
      <v-layout wrap justify-center v-if="$vuetify.breakpoint.smAndUp">
        <v-flex xs6 sm6 md6 lg6 xl6 style="display: flex; justify-content: center; margin-top: -4vh;">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12 md12 lg12 xl12>
                <div class="Setting">
                  <div style="margin-top: 1em;">
                    <ul class="List_Register">
                        <div class="List_item_header">
                          <p  class="SettingTtl">รูปร้านค้า</p>
                        </div>
                        <div  class="List_item_body">
                          <div class="SettingImg" style="display: flex !important; align-items: center !important; justify-content: center !important;">
                            <div class="SettingImgWrap">
                              <div>
                                <img :src="require('../../assets/robot1.png')" class="alligator-turtle" style=" cursor: pointer; width: 150px; height: 150px;" @click="uppic" v-if="imageData == ''">
                                <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style=" cursor: pointer; width: 150px; height: 150px;">

                                <div style="display: none;">
                                  <input class="CSChatThai" type="file" name="file1"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofilebot"/>
                                </div>
                                <label for="SettingImg" class="SettingImgBtn" @click="uppicbot">
                                  อัพโหลด
                                </label>
                              </div>
                              <input data-v-0c521aa4="" type="file" name="file" id="uploadpicprofilebot" class="SettingImgInput" @change="previewImageprofiles">
                            </div>
                          </div>
                          <p class="EditAreaNote">รองรับไฟล์ .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                        </div>
                    </ul>
                  </div>
                  <div class="">
                     <v-form  ref="form" lazy-validation class="CSChatThai labeltext">
                    <p class="SettingTtl">ID ร้านค้า :  <span style="color: red; font-weight: 400;"> *
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <div>ไอดีร้านค้าหรือไอดีบอท เป็นไอดีสำหรับใช้ค้นหาบอทเพื่อเพิ่มเพื่อน (สามารถใช้ได้ทั้งอักษรภาษาอังกฤษ ตัวเลข และอักขระพิเศษ)</div>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <!-- <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input type="text"  class="InputEdit" v-model="botid" placeholder="ไอดีสำหรับการค้นหา เพิ่มเพื่อน"
                            >
                          </div>
                          <p class="EditAreaNote" style="color:red; justify-content: left; display: flex;">{{botiderror}}</p>
                           <p class="EditAreaNote" style="color:green; justify-content: left; display: flex;" v-if="botid != '' && botidstatus"><i class="fas fa-check" style="color:green;"></i> ID ร้านค้าสามารถใช้ได้</p>
                        </div> -->
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input @keypress="isNumandaz($event)" type="text"  class="InputEdit" v-model="botid" placeholder="ไอดีสำหรับการค้นหา เพิ่มเพื่อน"
                              style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;"
                            >
                          </div>
                          <div v-if="progressCheckId" style="justify-content: start; display: flex; margin-left: 10px;margin-top: 10px;">
                            <v-progress-circular :size="15" :width="3" :indeterminate="progressCheckId" color="gray"></v-progress-circular>
                          </div>
                          <div v-else>
                            <p class="EditAreaNote" style="color:red; justify-content: left; display: flex;">{{botiderror}}</p>
                            <p class="EditAreaNote" style="color:green; justify-content: left; display: flex;" v-if="botid != '' && botidstatus"><i class="fas fa-check" style="color:green;"></i> ID ร้านค้าสามารถใช้ได้</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl" style="margin-top:2vh;">ชื่อร้านค้า :  <span style="color: red; font-weight: 400;"> *
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <span>ชื่อร้านค้าหรือชื่อบอท เป็นชื่อที่ผู้ใช้ทั่วไปมองเห็น(สามารถแก้ไขภายหลังได้)</span>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input type="text" placeholder="ชื่อที่บุคคลทั่วไปเห็น" class="InputEdit" v-model="botname"
                              style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;"
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl" style="margin-top:2vh;">ประเภทร้านค้า :
                      <span style="color: red; font-weight: 400;"> *
                        <v-tooltip right max-width="250px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                          </template>
                          <span>ประเภทร้านค้าหรือประเภทบอท</span>
                        </v-tooltip>
                      </span></p>
                    <div>
                      <div class="EditArea">
                        <div class="EditAreaCont">
                          <div class="EditAreaContFlex">
                            <v-select
                              :items="items"
                              label="กรุณาเลือกประเภทร้านค้า"
                              solo
                              v-model="detail"
                            ></v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl">รหัสเพิ่มเพื่อน : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                      <v-tooltip right max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <div>รหัสเพิ่มเพื่อน คือ รหัสผ่านที่ใช้ในการเพิ่มร้านค้าหรือเพิ่มแชทบอทสำหรับผู้ที่ต้องการจำกัดสิทธิ์ในการเพิ่มบอทเป็นเพื่อน
                          ให้เฉพาะผู้ที่มีรหัสเพิ่มเพื่อนเท่านั้นที่สามารถเพิ่มบอทหรือร้านค้าเป็นเพื่อนได้แต่สำหรับในกรณีที่ต้องการให้คนทั่วไปสามารถ
                          ค้นหาและเพิ่มร้านค้าได้เลยไม่จำเป็นต้องกรอกรหัสเพิ่มเพื่อน (รหัสเพิ่มเพื่อน สามารถเพิ่มและแก้ไขในภายหลังได้)
                        </div>
                        <!-- <div>เฉพาะผู้ที่มีรหัสเพิ่มเพื่อนเท่านั้นที่สามารถเพิ่มบอทหรือร้านค้าเป็นเพื่อนได้แต่สำหรับในกรณีที่ต้องการให้คนทั่วไปสามารถ</div>
                        <div>ค้นหาและเพิ่มร้านค้าได้เลยไม่จำเป็นต้องกรอกรหัสเพิ่มเพื่อน (รหัสเพิ่มเพื่อน สามารถเพิ่มและแก้ไขในภายหลังได้)</div> -->
                      </v-tooltip>
                    </span></p>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <v-text-field
                              v-model="botpassword"
                              :rules="passwordRules"
                              label="รหัสสำหรับเพิ่มเพื่อน"
                              counter
                              solo
                              maxlength="6"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                      <p class="SettingTtl">ยืนยันรหัส : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                        <v-tooltip right max-width="250px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                          </template>
                          <span style="wigth:40%;">ยืนยันรหัสเพิ่มเพื่อน</span>
                        </v-tooltip>
                      </span></p>
                      <div>
                        <div class="EditArea">
                          <div  class="EditAreaCont">
                            <div  class="EditAreaContFlex">
                              <v-text-field
                                v-model="repassword"
                                :rules="repasswordRules"
                                label="ยืนยันรหัสสำหรับเพิ่มเพื่อน"
                                counter
                                solo
                                maxlength="6"
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                    </div>
                    <p class="SettingTtl">ข้อความตอบกลับ หลังเพิ่มเพื่อน : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                          <span>ข้อความตอบกลับหลังเพิ่มเพื่อน เป็นข้อความตอบกลับอัตโนมัติหลังจากมีการเพิ่มบอทหรือร้านค้าเป็นเพื่อน</span>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input type="text" placeholder="ข้อความตอบกลับอัตโนมัติ หลังการเพิ่มเพื่อน" class="InputEdit" v-model="msg_reply" style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;">
                          </div>
                        </div>
                      </div>
                    </div>
                    </v-form>
                  </div>
                </div>
              </v-flex>
              <v-flex sm12 md12 lg12 xl12 style="display: flex;justify-content: center">
                <v-btn :loading="loading" :disabled="botidstatus == '' || botname == '' || detail == ''" class="buttoncreate"  @click="submit()">
                  <span>สร้างร้านค้า</span>
                </v-btn>
                <v-btn class="buttonclear" @click="clearinfo()">
                  <span style="color: white;">ล้างข้อมูล</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <br>
      </v-layout>

      <v-layout wrap justify-center v-if="$vuetify.breakpoint.xs">
        <v-flex xs12 style="display: flex; justify-content: center; margin-top: -4vh;">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <div class="Setting">
                  <div style="margin-top: 1em;">
                    <ul class="List_Register">
                        <div class="List_item_header">
                          <p  class="SettingTtl">รูปร้านค้า</p>
                        </div>
                        <div  class="List_item_body">
                          <div class="SettingImg" style="display: flex !important; align-items: center !important; justify-content: center !important;">
                            <div class="SettingImgWrap">
                              <div>
                                <img :src="require('../../assets/robot1.png')" class="alligator-turtle" style=" cursor: pointer; width: 150px; height: 150px;" @click="uppic" v-if="imageData == ''">
                                <img :src="imageData" class="alligator-turtle" @click="uppic" v-else style=" cursor: pointer; width: 150px; height: 150px;">

                                <div style="display: none;">
                                  <input class="CSChatThai" type="file" name="file1"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofilebot"/>
                                </div>
                                <label for="SettingImg" class="SettingImgBtn" @click="uppicbot">
                                  อัพโหลด
                                </label>
                              </div>
                              <input data-v-0c521aa4="" type="file" name="file" id="uploadpicprofilebot" class="SettingImgInput" @change="previewImageprofiles">
                            </div>
                          </div>
                          <p class="EditAreaNote">รองรับไฟล์ .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
                        </div>
                    </ul>
                  </div>
                  <div class="">
                     <v-form  ref="form" lazy-validation class="CSChatThai labeltext">
                    <p class="SettingTtl">ID ร้านค้า :  <span style="color: red; font-weight: 400;"> *
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <div>ไอดีร้านค้าหรือไอดีบอท เป็นไอดีสำหรับใช้ค้นหาบอทเพื่อเพิ่มเพื่อน (สามารถใช้ได้ทั้งอักษรภาษาอังกฤษ ตัวเลข และอักขระพิเศษ)</div>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input @keypress="isNumandaz($event)" type="text"  class="InputEdit" v-model="botid" placeholder="ไอดีสำหรับการค้นหา เพิ่มเพื่อน"
                              style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;"
                            >
                          </div>
                          <div v-if="progressCheckId" style="justify-content: start; display: flex; margin-left: 10px;margin-top: 10px;">
                            <v-progress-circular :size="15" :width="3" :indeterminate="progressCheckId" color="gray"></v-progress-circular>
                          </div>
                          <div v-else>
                            <p class="EditAreaNote" style="color:red; justify-content: left; display: flex;">{{botiderror}}</p>
                            <p class="EditAreaNote" style="color:green; justify-content: left; display: flex;" v-if="botid != '' && botidstatus"><i class="fas fa-check" style="color:green;"></i> ID ร้านค้าสามารถใช้ได้</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl" style="margin-top:2vh;">ชื่อร้านค้า :  <span style="color: red; font-weight: 400;"> *
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <span>ชื่อร้านค้าหรือชื่อบอท เป็นชื่อที่ผู้ใช้ทั่วไปมองเห็น(สามารถแก้ไขภายหลังได้)</span>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input type="text" placeholder="ชื่อที่บุคคลทั่วไปเห็น" class="InputEdit" v-model="botname"
                              style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;"
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl" style="margin-top:2vh;">ประเภทร้านค้า :
                      <span style="color: red; font-weight: 400;"> *
                        <v-tooltip right max-width="250px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                          </template>
                          <span>ประเภทร้านค้าหรือประเภทบอท</span>
                        </v-tooltip>
                      </span></p>
                    <div>
                      <div class="EditArea">
                        <div class="EditAreaCont">
                          <div class="EditAreaContFlex">
                            <v-select
                              :items="items"
                              label="กรุณาเลือกประเภทร้านค้า"
                              solo
                              v-model="detail"
                            ></v-select>
                          </div>
                        </div>
                      </div>
                    </div>
                    <p class="SettingTtl">รหัสเพิ่มเพื่อน : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                      <v-tooltip right max-width="350px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                        <div>รหัสเพิ่มเพื่อน คือ รหัสผ่านที่ใช้ในการเพิ่มร้านค้าหรือเพิ่มแชทบอทสำหรับผู้ที่ต้องการจำกัดสิทธิ์ในการเพิ่มบอทเป็นเพื่อน
                          ให้เฉพาะผู้ที่มีรหัสเพิ่มเพื่อนเท่านั้นที่สามารถเพิ่มบอทหรือร้านค้าเป็นเพื่อนได้แต่สำหรับในกรณีที่ต้องการให้คนทั่วไปสามารถ
                          ค้นหาและเพิ่มร้านค้าได้เลยไม่จำเป็นต้องกรอกรหัสเพิ่มเพื่อน (รหัสเพิ่มเพื่อน สามารถเพิ่มและแก้ไขในภายหลังได้)
                        </div>
                      </v-tooltip>
                    </span></p>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <v-text-field
                              v-model="botpassword"
                              :rules="passwordRules"
                              label="รหัสสำหรับเพิ่มเพื่อน"
                              counter
                              solo
                              maxlength="6"
                            ></v-text-field>
                          </div>
                        </div>
                      </div>
                      <p class="SettingTtl">ยืนยันรหัส : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                        <v-tooltip right max-width="250px">
                          <template v-slot:activator="{ on }">
                            <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                          </template>
                          <span style="wigth:40%;">ยืนยันรหัสเพิ่มเพื่อน</span>
                        </v-tooltip>
                      </span></p>
                      <div>
                        <div class="EditArea">
                          <div  class="EditAreaCont">
                            <div  class="EditAreaContFlex">
                              <v-text-field
                                v-model="repassword"
                                :rules="repasswordRules"
                                label="ยืนยันรหัสสำหรับเพิ่มเพื่อน"
                                counter
                                solo
                                maxlength="6"
                              ></v-text-field>
                            </div>
                          </div>
                        </div>
                    </div>
                    <p class="SettingTtl">ข้อความตอบกลับ หลังเพิ่มเพื่อน : <span style="font-weight: normal; margin-left: 5px;"> (ถ้ามี)
                      <v-tooltip right max-width="250px">
                        <template v-slot:activator="{ on }">
                          <v-icon color="#909090" dark v-on="on" small style="cursor: pointer;">fas fa-info-circle</v-icon>
                        </template>
                          <span>ข้อความตอบกลับหลังเพิ่มเพื่อน เป็นข้อความตอบกลับอัตโนมัติหลังจากมีการเพิ่มบอทหรือร้านค้าเป็นเพื่อน</span>
                      </v-tooltip>
                    </span></p>
                    <div>
                      <div class="EditArea">
                        <div  class="EditAreaCont">
                          <div  class="EditAreaContFlex">
                            <input type="text" placeholder="ข้อความตอบกลับอัตโนมัติ หลังการเพิ่มเพื่อน" class="InputEdit" v-model="msg_reply" style="border-radius: 50px; border: 2px solid #607d8b; border-width: thin;">
                          </div>
                        </div>
                      </div>
                    </div>
                    </v-form>
                  </div>
                </div>
              </v-flex>
              <v-flex sm12 md12 lg12 xl12 style="display: flex;justify-content: center">
                <v-btn :loading="loading" :disabled="botidstatus == '' || botname == '' || detail == ''" class="buttoncreate"  @click="submit()">
                  <span>สร้างร้านค้า</span>
                </v-btn>
                <v-btn class="buttonclear" @click="clearinfo()">
                  <span style="color: white;">ล้างข้อมูล</span>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
        <br>
      </v-layout>
    </v-card-text>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import { Decode } from '@/services'
// import Vue from 'vue'
// import VueQrcode from '@xkeshi/vue-qrcode'
// Vue.component(VueQrcode.name, VueQrcode)
export default {
  data () {
    return {
      progressCheckId: false,
      show_market: false,
      imageData: '',
      items: [
        'ผู้เชี่ยวชาญ',
        'ร้านอาหารและเครื่องดื่ม',
        'ยานพาหนะ',
        'อสังหาริมทรัพย์',
        'การศึกษา',
        'การท่องเที่ยว',
        'ธุรกิจบันเทิง',
        'สุขภาพ',
        'ความงาม',
        'องค์กร หรือสถาบัน',
        'หน่วยงานราชการ',
        'ธุรกิจบริการ',
        'ค้าขาย, ร้านค้า',
        'ธุรกิจในพื้นที่ประเภทอื่น',
        'องค์กรธุรกิจ, กลุ่มองค์กร',
        'แบรนด์, ผลิตภัณฑ์',
        'หนังสือ, นิตยสาร, หนังสือพิมพ์',
        'ภาพยนตร์',
        'ดนตรี',
        'กีฬา',
        'โทรทัศน์',
        'เว็บไซต์&บล็อก'
      ],
      loader: null,
      loading: false,
      development: '',
      token: '',
      name: '',
      status: '',
      TypeSearch: '',
      search: '',
      NewArray: [], // เอาไว้รับค่าที่ socket ส่งมาเพื่อเก็บไว้
      ArrayList: [], // เอาไว้เก็บข้อมูลเพื่อทำการ push เก็บรอการส่งเข้า global variable
      tokenFriend: '',
      filename: '',
      webbackend: '',
      botid: '',
      botiderror: '',
      botidstatus: false,
      botname: '',
      detail: '',
      webhook: '',
      msg_reply: '',
      usernameRules: [
        v => (!!v && v.length >= 6) || 'กรุณาใส่ตัวอักษรอย่างน้อย 6 ตัว',
        v => /^([a-z0-9])+$/.test(v) || 'กรุณาใส่ชื่อผู้ใช้งานเป็นภาษาอังกฤษ a-z และ 0-9 เท่านั้น',
        v => /[^\W_]+$/.test(v) || 'ไม่สามารถใช้อักขระพิเศษได้'
      ],
      nameEnRules: [
        v => !!v || 'กรุณากรอกข้อมูล',
        v => /^([A-z ])+$/.test(v) || 'กรุณากรอกภาษาอังกฤษ'
      ],
      windowWidth: '',
      selectFile: '',
      passwordRules: [
        v => (!!v && v.length >= 6) || 'กรุณากรอกตัวเลขอย่างน้อย 6 ตัว',
        v => /^([0-9])+$/.test(v) || 'กรุณากรอกเป็นตัวเลข 0-9 เท่านั้น',
        v => /[^\W_]+$/.test(v) || 'ไม่สามารถกรอกตัวอักษรหรืออักขระพิเศษได้'
      ],
      botpassword: '',
      repasswordRules: [
        v => !!v || 'กรุณาใส่รหัสผ่านซ้ำ',
        v => v === this.botpassword || 'กรุณาใส่รหัสผ่านให้ตรงกัน'
      ],
      repassword: ''
    }
  },
  methods: {
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) { // 46 is dot
        $event.preventDefault()
      }
    },
    uppic () {
      document.getElementById('uploadpicprofilebot').click()
    },
    uppicbot () {
      document.getElementById('uploadpicprofilebot').click()
    },
    previewImageprofiles (data) {
      var input = data.target
      this.selectFile = data.target.files[0]
      if (input.files && input.files[0]) {
        var reader = new FileReader()
        reader.onload = (e) => {
          this.imageData = e.target.result
        }
        reader.readAsDataURL(input.files[0])
      }
    },
    clearinfo () {
      this.$swal({
        title: 'ยืนยันการล้างข้อมูล',
        text: 'คุณต้องการล้างข้อมูลใช่หรือไม่?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ตกลง',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.value) {
          this.botid = ''
          this.botname = ''
          this.detail = ''
          this.webhook = ''
          this.msg_reply = ''
          this.botiderror = ''
          this.botidstatus = false
          this.botpassword = ''
          this.repassword = ''
          this.$refs.form.reset()
        }
      })
    },
    checkID () {
      if (this.botid !== '') {
        this.progressCheckId = true
        this.axios.post(process.env.VUE_APP_API_MANAGE + '/checkbotid', { bot_id: this.botid }).then((response) => {
          if (response.data['status'] === 'success') {
            this.progressCheckId = false
            this.botiderror = ''
            this.botidstatus = true
          } else if (response.data['status'] === 'fail' && response.data['message'] === 'id duplicate') {
            this.progressCheckId = false
            this.botiderror = 'ไอดีนี้ถูกใช้ไปแล้ว'
            this.botidstatus = false
          }
        }).catch(error => {
          console.log(error)
          this.progressCheckId = false
        })
      }
    },
    submit () {
      this.loader = 'loading'
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/createbot2', {
        token_owner: this.token,
        bot_id: this.botid,
        bot_name: this.botname,
        detail: this.detail,
        webhook: '',
        message_default: this.msg_reply,
        password: this.botpassword
      }).then((response) => {
        // console.log(response.data)
        if (response.data['status'] === 'success') {
          if (this.selectFile !== '') {
            var uploadFile = new FormData()
            uploadFile.append('file', this.selectFile, this.selectFile.name)
            uploadFile.append('tokenuser', response.data.tokenBot)
            this.axios.post(process.env.VUE_APP_API_MANAGE + '/setpictureprofileuser', uploadFile).then((responsed) => {
              // console.log(responsed.data)
              if (responsed.data.status === 'success') {
                this.$swal(
                  'สร้างบัญชีร้านค้าสำเร็จ',
                  '',
                  'success')
                this.selectFile = ''
                this.imageData = ''
                this.route_botid({ 'message_default': this.msg_reply, 'webhook': this.webhook, 'nickname': this.botname, 'profilepicture': responsed.data.filename, 'tokenuser': response.data.tokenBot, 'type': 'bot', 'bot_id': this.botid })
                this.$emit('updatelistbot', this.botid)
                this.loader = null
                // this.clearinfo()
                this.botid = ''
                this.botname = ''
                this.detail = ''
                this.webhook = ''
                this.msg_reply = ''
                this.botiderror = ''
                this.botidstatus = false
                this.botpassword = ''
                this.repassword = ''
                this.$refs.form.reset()
              }
            })
          } else {
            this.$swal(
              'สร้างบัญชีร้านค้าสำเร็จ',
              '',
              'success')
            this.route_botid({
              'message_default': this.msg_reply,
              'webhook': this.webhook,
              'nickname': this.botname,
              'profilepicture': '',
              'tokenuser': response.data.tokenBot,
              'type': 'bot',
              'bot_id': this.botid,
              'password': this.botpassword
            })
            this.$emit('updatelistbot', this.botid)
            this.loader = null
            // this.clearinfo()
            this.botid = ''
            this.botname = ''
            this.detail = ''
            this.webhook = ''
            this.msg_reply = ''
            this.botiderror = ''
            this.botidstatus = false
            this.botpassword = ''
            this.repassword = ''
            this.$refs.form.reset()
          }
          // console.log(response.body)
        } else {
          // this.$swal(
          //   'สร้างบอทไม่สำเร็จ',
          //   'เนื่องจากเซิร์ฟเวอร์มีปัญหา กรุณาติดต่อผู้ดูแลระบบ.',
          //   'error'
          // )
          this.loader = null
        }
      }, (response) => {
      })
    },
    route_botid (data) {
      // this.$store.dispatch('tokenRoom', data.bot_id)
      // this.$store.dispatch('changeBot', data)
      // localStorage.setItem('room', data.bot_id)
      // this.$store.dispatch('changeRightTool', 'Friend')
      // this.$cookies.set('tokenRoom', data.bot_id)
      this.$router.push('/listchat/' + data.tokenuser)
    },
    toPage () {
      this.$router.go(-1)
    }
  },
  computed: {
    ...mapState({
      myprofile: 'myprofile'
    })
  },
  mounted () {
    // this.$nextTick(() => {
    //   window.addEventListener('resize', () => {
    //     this.windowWidth = window.innerWidth
    //   })
    // })
  },
  watch: {
    windowWidth () {
      if (this.windowWidth <= 960) {
        this.$router.push('/mobile/dev_createbot')
      }
    },
    myprofile () {
      console.log('myProfile')
      this.filename = localStorage.getItem('profilepicture')
    },
    botid () {
      if (this.botid === '') {
        this.botidstatus = false
      } else {
        this.checkID()
      }
    },
    loader () {
      const l = this.loader
      this[l] = !this[l]
      setTimeout(() => (this[l] = false), 3000)
      this.loader = null
    }
  },
  created () {
    // this.phone = localStorage.getItem('phone')
    // this.email = localStorage.getItem('email')
    this.token = Decode.decodeToken(localStorage.getItem('tokenuser'))
    this.tokenservice = Decode.decodeToken(localStorage.getItem('tokenservice'))
    // this.token = localStorage.getItem('tokenuser')
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.webbackend = process.env.API
    this.filename = localStorage.getItem('profilepicture')
    this.development = '-'
    // this.tokenservice = localStorage.getItem('tokenservice')
    this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(localStorage.getItem('email'))
    this.nameedit = this.name
    this.statusedit = this.status
  }
}
</script>
<style type="text/css" scoped>
>>>.v-label {
  font-size: 14px;
  line-height: 2;
  min-height: 8px;
  -webkit-transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}
>>>.v-messages__message {
  -ms-hyphens: auto;
  -webkit-hyphens: auto;
  hyphens: auto;
  line-height: 2;
  overflow-wrap: break-word;
  word-break: break-word;
  word-wrap: break-word;
  color: rgb(230, 25, 52);
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
  border-style: solid;
  border-width: thin !important;
  border-radius: 50px;
  border-color: #d2d8dd;
  border: 2px solid #607d8b;
}
.buttonclear {
  /* border-style: solid !important; */
  border-radius: 50px !important;
  background-color: #7f878f !important;
  border-color: #bdbdbd !important;
  width: 105px !important;
  box-shadow: none !important;
}
.buttoncreate {
  /* border-style: solid !important; */
  border-radius: 50px !important;
  background-color: #4268fb !important;
  /* border-color: #bdbdbd !important; */
  width: 105px !important;
  color: white !important;
  box-shadow: none !important;
  /* border-color: #b7e5a2 !important; */
}
.scrolling-wrapper {
  display: flex;
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 10px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
>>>.container {
  -webkit-box-flex: 1;
  -ms-flex: 1 1 100%;
  flex: 1 1 100%;
  margin: auto;
  /* padding: 24px; */
  width: 100%;
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
    /*margin-top: 5vh;*/
    /*Using a background color, but you can use a background image to represent a button*/
    /*background-color: #DDF;*/
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    justify-content: left;
    display: flex;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    margin: 40px 0 20px;
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #607d8b;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 20px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
    justify-content: left;
    display: flex;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    /* border-radius: 40px;
    overflow: hidden; */
    border-radius: 30px;
    overflow: hidden;
    border-style: solid;
    border-width: thin;
    border-color: #bdbdbd;
    /* padding: 10px; */
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
.buttonsubmit {
  background-color: #607d8b !important;
  border-radius: 8px !important;
  color: white !important;
  text-transform: none !important;
}
.buttoncancel {
  border-radius: 8px !important;
  color: #4c4c4c !important;
  text-transform: none !important;
  border-color: #8080807d !important;
  border-style: solid !important;
  border-width: thin !important;
}
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.BGwhite {
  background-color: white !important;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;
}*/
</style>
